const faqs = [
  {
    q: '吃瓜爆料网是什么？',
    a: '吃瓜爆料网是一个专注娱乐八卦与黑料爆料的资讯聚合平台，覆盖博主反差视频、明星塌房现场、圈内潜规则等一手爆料内容。本站为官方发布页，提供App下载、网站入口和最新地址导航。',
  },
  {
    q: '如何下载吃瓜爆料网App？',
    a: '访问本站App下载专区即可获取最新安装包。吃瓜爆料网App支持iOS和Android双平台，请认准官方渠道下载以保证安全。下载入口位于页面#app区域。',
  },
  {
    q: '吃瓜爆料网最新地址在哪里找？',
    a: '本站即为吃瓜爆料网官方发布页，始终提供最新有效地址。建议收藏本页面以获取持续更新的网站入口，避免因旧地址失效而错过精彩内容。',
  },
  {
    q: '吃瓜爆料网的内容真实性如何？',
    a: '吃瓜爆料网的内容来源于多方渠道，包括圈内人士投稿、网友爆料和媒体公开报道。我们建议读者理性看待所有爆料信息，本站仅做信息聚合展示，不代表对内容真实性的背书。',
  },
  {
    q: '如何向吃瓜爆料网投稿或爆料？',
    a: '可通过本站的联系投稿入口提交你的爆料线索。我们欢迎真实可靠的圈内情报，收到投稿后会进行评估处理。请注意保护个人隐私安全。',
  },
  {
    q: '吃瓜爆料网和吃瓜爆料网站有什么区别？',
    a: '吃瓜爆料网是平台品牌名称，吃瓜爆料网站则泛指该品牌下的所有站点资源。本站作为官方发布页，统一整理App下载入口、网站地址和最新域名，方便用户一站式触达所有资源。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">常见问题</h2>
          <p className="text-sm text-foreground-500">关于吃瓜爆料网的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-open:hidden">
                  <i className="ri-add-line text-lg"></i>
                </span>
                <span className="flex-shrink-0 w-6 h-6 hidden group-open:flex items-center justify-center text-foreground-400">
                  <i className="ri-subtract-line text-lg"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}